var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFxCircle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-1",
    opacity: 1,
    fillRule: "evenodd",
    d: "M47.58749999999988,29.362499999999994 C46.91249999999988,35.099999999999994 44.043749999999896,39.82500000000001 39.82499999999992,43.20000000000001 C35.606249999999946,46.57500000000002 30.206249999999986,48.26250000000002 24.468750000000014,47.58750000000002 C18.73125000000005,46.912500000000016 14.006250000000076,44.04375000000001 10.631250000000101,39.82500000000001 C7.256250000000119,35.60625 5.568750000000129,30.206249999999997 6.243750000000126,24.468749999999993 C6.918750000000121,18.73124999999999 9.787500000000104,14.006249999999978 14.00625000000008,10.631249999999978 C18.225000000000055,7.256249999999975 23.625000000000025,5.568749999999973 29.36249999999999,6.243749999999974 L29.02499999999999,8.606249999999976 L28.687499999999993,11.137499999999978 C24.300000000000022,10.631249999999978 20.081250000000047,11.981249999999982 17.043750000000063,14.512499999999982 C13.83750000000008,17.043749999999985 11.643750000000093,20.92499999999999 11.137500000000099,25.312499999999996 C10.631250000000101,29.7 11.981250000000092,33.91875 14.512500000000077,36.95625000000001 C17.043750000000063,40.162500000000016 20.925000000000036,42.35625000000001 25.312500000000014,42.86250000000002 C29.699999999999992,43.36875000000001 33.91874999999996,42.01875000000002 36.95624999999994,39.48750000000002 C40.16249999999992,36.95625000000001 42.35624999999992,33.243750000000006 42.86249999999991,28.687499999999996 L45.224999999999895,29.024999999999995 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-2",
    opacity: 1,
    fillRule: "evenodd",
    d: "M28.518749999999745,53.831250000000004 C26.999999999999904,54 25.312500000000085,53.831250000000004 23.793750000000244,53.6625 L24.300000000000193,49.78125 C25.65000000000005,49.95 26.999999999999904,49.95 28.181249999999782,49.95 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-3",
    opacity: 1,
    fillRule: "evenodd",
    d: "M33.41250000000012,53.156249999999986 C32.231250000000124,53.493749999999984 30.881250000000122,53.66249999999999 29.53125000000012,53.83124999999998 L29.193750000000122,49.94999999999997 L32.231250000000124,49.443749999999966 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-4",
    opacity: 1,
    fillRule: "evenodd",
    d: "M38.47500000000012,51.299999999999976 C37.12500000000012,51.974999999999966 35.94375000000012,52.48124999999997 34.425000000000125,52.818749999999966 L33.41250000000012,49.10624999999998 C34.59375000000012,48.76874999999998 35.606250000000124,48.431249999999984 36.61875000000012,47.92499999999998 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-5",
    opacity: 1,
    fillRule: "evenodd",
    d: "M42.86249999999975,48.76875000000001 C41.849999999999746,49.61250000000001 40.66874999999975,50.287500000000016 39.48749999999975,50.79375000000002 L37.79999999999975,47.25000000000001 C38.81249999999975,46.743750000000006 39.65624999999975,46.2375 40.49999999999975,45.5625 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-6",
    opacity: 1,
    fillRule: "evenodd",
    d: "M47.08124999999975,44.88750000000002 C46.06874999999979,46.06875000000001 44.88749999999984,47.08125000000001 43.7062499999999,48.09375 L41.34375,45.05625000000001 C42.35624999999996,44.21250000000001 43.36874999999991,43.36875000000002 44.21249999999988,42.35625000000002 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-7",
    opacity: 1,
    fillRule: "evenodd",
    d: "M50.11874999999987,40.83750000000002 C49.44374999999992,42.01875000000002 48.76874999999997,43.03125000000002 47.925000000000026,44.04375000000002 L44.887500000000244,41.51250000000002 C45.56250000000019,40.66875000000002 46.237500000000146,39.82500000000002 46.74375000000011,38.98125000000002 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-8",
    opacity: 1,
    fillRule: "evenodd",
    d: "M52.3125,35.94375 C51.80625,37.29375 51.3,38.64375000000001 50.625,39.82500000000002 L47.25,37.80000000000001 C47.75625,36.7875 48.2625,35.775000000000006 48.76875,34.59375 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-9",
    opacity: 1,
    fillRule: "evenodd",
    d: "M53.66250000000012,31.218750000000036 C53.49375000000012,32.56875000000004 53.15625000000013,33.750000000000036 52.81875000000014,34.931250000000034 L49.106250000000244,33.750000000000036 C49.443750000000236,32.73750000000003 49.61250000000023,31.725000000000037 49.78125000000022,30.712500000000034 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-10",
    opacity: 1,
    fillRule: "evenodd",
    d: "M53.831250000000004,25.3125 C54,26.83124999999999 53.831250000000004,28.518749999999976 53.6625,30.03749999999997 L49.78125,29.53124999999997 C49.95,28.18124999999998 49.95,26.83124999999999 49.95,25.649999999999995 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-11",
    opacity: 1,
    fillRule: "evenodd",
    d: "M53.15624999999981,20.41875000000002 C53.49374999999978,21.60000000000002 53.66249999999977,22.95000000000002 53.83124999999975,24.30000000000002 L49.95000000000008,24.637500000000017 L49.44375000000012,21.600000000000016 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-12",
    opacity: 1,
    fillRule: "evenodd",
    d: "M51.30000000000002,15.356250000000017 C51.975000000000065,16.70625000000002 52.4812500000001,17.887500000000017 52.81875000000013,19.406250000000018 L49.10624999999985,20.418750000000017 C48.76874999999982,19.23750000000002 48.43124999999979,18.225000000000016 47.924999999999756,17.212500000000016 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-13",
    opacity: 1,
    fillRule: "evenodd",
    d: "M48.76875000000015,11.137500000000017 C49.612500000000196,12.150000000000016 50.28750000000023,13.331250000000017 50.79375000000025,14.512500000000017 L47.25000000000008,16.200000000000017 C46.743750000000055,15.187500000000018 46.23750000000003,14.343750000000018 45.5625,13.500000000000018 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-14",
    opacity: 1,
    fillRule: "evenodd",
    d: "M44.88750000000014,6.75 C46.06875000000009,7.762499999999997 47.08125000000005,8.943749999999994 48.09375,10.124999999999991 L45.05625000000013,12.487499999999985 C44.21250000000016,11.474999999999987 43.368750000000205,10.46249999999999 42.356250000000244,9.618749999999991 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-15",
    opacity: 1,
    fillRule: "evenodd",
    d: "M40.83750000000025,3.8812499999999672 C42.018750000000246,4.556249999999969 43.03125000000025,5.231249999999971 44.043750000000244,6.0749999999999735 L41.512500000000244,9.112499999999983 C40.668750000000244,8.437499999999979 39.825000000000244,7.762499999999978 38.981250000000244,7.256249999999976 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-16",
    opacity: 1,
    fillRule: "evenodd",
    d: "M35.94375000000006,1.5187499999999832 C37.293750000000124,2.024999999999983 38.643750000000196,2.531249999999983 39.825000000000244,3.206249999999983 L37.80000000000015,6.581249999999983 C36.7875000000001,6.074999999999983 35.775000000000055,5.568749999999983 34.59375,5.062499999999983 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-17",
    opacity: 1,
    fillRule: "evenodd",
    d: "M31.21874999999988,0.33750000000003055 C32.56874999999988,0.506250000000029 33.74999999999988,0.8437500000000253 34.93124999999988,1.1812500000000217 L33.74999999999988,4.893749999999983 C32.737499999999876,4.556249999999986 31.72499999999988,4.387499999999989 30.712499999999878,4.21874999999999 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-18",
    opacity: 1,
    fillRule: "evenodd",
    d: "M25.3125,0 C26.999999999999915,0 28.518749999999834,0 30.20624999999975,0.16874999999999937 L29.699999999999772,4.049999999999985 C28.34999999999984,3.881249999999985 26.99999999999991,3.881249999999985 25.81874999999997,3.881249999999985 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-19",
    opacity: 1,
    fillRule: "evenodd",
    d: "M20.418750000000248,0.8437500000000195 C21.600000000000247,0.5062500000000183 22.950000000000248,0.3375000000000177 24.300000000000246,0.16875000000001705 L24.637500000000244,4.050000000000031 L21.600000000000243,4.556250000000032 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-20",
    opacity: 1,
    fillRule: "evenodd",
    d: "M15.356250000000252,2.5312500000000124 C16.706250000000253,1.8562500000000146 17.88750000000025,1.350000000000016 19.406250000000252,1.012500000000017 L20.41875000000025,4.725000000000006 C19.237500000000253,5.062500000000005 18.22500000000025,5.400000000000003 17.21250000000025,5.906250000000002 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-21",
    opacity: 1,
    fillRule: "evenodd",
    d: "M11.137500000000252,5.231249999999983 C12.15000000000025,4.387499999999983 13.331250000000251,3.712499999999983 14.512500000000252,3.206249999999983 L16.20000000000025,6.749999999999982 C15.187500000000252,7.087499999999983 14.343750000000252,7.593749999999982 13.500000000000252,8.268749999999983 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-22",
    opacity: 1,
    fillRule: "evenodd",
    d: "M6.75,9.112499999999992 C7.762499999999955,7.931249999999994 8.943749999999904,6.9187499999999975 10.124999999999853,5.90625 L12.48749999999975,8.943749999999993 C11.474999999999795,9.78749999999999 10.462499999999839,10.631249999999987 9.618749999999874,11.643749999999985 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-23",
    opacity: 1,
    fillRule: "evenodd",
    d: "M3.8812500000001235,12.993749999999974 C4.556250000000075,11.812499999999972 5.231250000000026,10.799999999999969 6.0749999999999655,9.787499999999966 L9.112499999999748,12.318749999999973 C8.437499999999796,13.162499999999977 7.762499999999845,14.17499999999998 7.25624999999988,15.018749999999981 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-24",
    opacity: 1,
    fillRule: "evenodd",
    d: "M1.5187499999997487,17.887499999999974 C2.0249999999997725,16.53749999999997 2.6999999999998052,15.187499999999968 3.3749999999998375,14.006249999999966 L6.749999999999998,16.03124999999997 C6.243749999999975,17.043749999999974 5.737499999999949,18.056249999999977 5.2312499999999265,19.237499999999983 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-25",
    opacity: 1,
    fillRule: "evenodd",
    d: "M0.33749999999987423,22.781249999999964 C0.5062499999998696,21.431249999999963 0.8437499999998603,20.249999999999964 1.181249999999851,19.068749999999966 L4.893749999999749,20.249999999999964 C4.556249999999758,21.262499999999964 4.387499999999764,22.274999999999963 4.218749999999767,23.287499999999966 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-26",
    opacity: 1,
    fillRule: "evenodd",
    d: "M0,28.518749999999986 C0,26.999999999999996 0,25.481250000000006 0.1687499999999896,23.793750000000017 L4.04999999999975,24.300000000000015 C3.8812499999997603,25.650000000000006 3.8812499999997603,26.999999999999996 3.8812499999997603,28.18124999999999 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-27",
    opacity: 1,
    fillRule: "evenodd",
    d: "M0.843750000000194,33.412499999999966 C0.5062500000002228,32.23124999999997 0.33750000000023717,30.881249999999966 0.16875000000025153,29.531249999999964 L4.04999999999992,29.193749999999966 L4.556249999999876,32.23124999999997 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-28",
    opacity: 1,
    fillRule: "evenodd",
    d: "M2.531250000000174,38.474999999999966 C1.8562500000002087,37.124999999999964 1.3500000000002346,35.943749999999966 1.0125000000002515,34.42499999999997 L4.725000000000062,33.412499999999966 C5.062500000000045,34.593749999999964 5.400000000000028,35.60624999999997 5.906250000000002,36.61874999999996 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-29",
    opacity: 1,
    fillRule: "evenodd",
    d: "M5.231249999999845,42.86249999999998 C4.387499999999805,41.84999999999998 3.712499999999773,40.66874999999998 3.2062499999997485,39.48749999999998 L6.749999999999917,37.79999999999998 C7.256249999999941,38.812499999999986 7.7624999999999655,39.656249999999986 8.437499999999998,40.499999999999986 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-30",
    opacity: 1,
    fillRule: "evenodd",
    d: "M9.11249999999986,47.08124999999998 C7.9312499999999115,46.06874999999998 6.918749999999957,44.88749999999999 5.90625,43.70624999999999 L8.943749999999868,41.34375 C9.787499999999831,42.35625 10.631249999999795,43.36874999999999 11.64374999999975,44.21249999999999 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-31",
    opacity: 1,
    fillRule: "evenodd",
    d: "M12.993750000000125,50.11875000000003 C11.812500000000124,49.44375000000003 10.800000000000125,48.768750000000026 9.787500000000126,47.92500000000002 L12.318750000000126,44.88750000000001 C13.162500000000126,45.56250000000001 14.006250000000126,46.23750000000001 14.850000000000126,46.74375000000002 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-32",
    opacity: 1,
    fillRule: "evenodd",
    d: "M17.887499999999843,52.3125 C16.537499999999937,51.80625 15.187500000000036,51.3 14.006250000000122,50.625 L16.031249999999975,47.25 C17.043749999999903,47.75625 18.056249999999828,48.2625 19.23749999999975,48.76875 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-33",
    opacity: 1,
    fillRule: "evenodd",
    d: "M22.78125000000012,53.662499999999966 C21.43125000000012,53.49374999999997 20.25000000000012,53.15624999999997 19.068750000000122,52.81874999999998 L20.25000000000012,49.10625000000002 C21.26250000000012,49.443750000000016 22.27500000000012,49.61250000000001 23.287500000000122,49.78125000000001 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-34",
    opacity: 1,
    fillRule: "evenodd",
    d: "M32.062499999999886,8.606250000000017 C40.331250000000026,10.968750000000016 46.06875000000013,18.393750000000004 46.06875000000013,27 L44.2125000000001,27 C44.04375000000009,19.23750000000001 38.98125,12.487500000000015 31.556249999999878,10.462500000000015 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-full-circle-35",
    opacity: 1,
    fillRule: "evenodd",
    d: "M14.512500762939453,25.3125 C13.5,32.23124694824219 18.39375114440918,38.474998474121094 25.143749237060547,39.48749923706055 C32.0625,40.5 38.474998474121094,35.60624694824219 39.48750305175781,28.6875 C40.33125305175781,21.768749237060547 35.60625076293945,15.524999618530273 28.6875,14.51249885559082 C21.76875114440918,13.66874885559082 15.525001525878906,18.393749237060547 14.512500762939453,25.3125 L19.068750381469727,25.818748474121094 C18.393749237060547,30.206249237060547 21.431249618530273,34.256248474121094 25.818748474121094,34.931251525878906 C30.206249237060547,35.60625076293945 34.256248474121094,32.568748474121094 34.931251525878906,28.181251525878906 C35.60625076293945,23.793750762939453 32.568748474121094,19.743749618530273 28.181251525878906,19.068750381469727 C23.793750762939453,18.393749237060547 19.743749618530273,21.431249618530273 19.068750381469727,25.818748474121094 L14.512500762939453,25.3125Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-1",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-2",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-3",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-4",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-5",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-6",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-7",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-8",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-9",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-10",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-11",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-12",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-13",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-14",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-15",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-16",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-17",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-18",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-19",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-20",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-21",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-22",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-23",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-24",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-25",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-26",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-27",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-28",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-29",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-30",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-31",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-32",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-33",
    fill: "rgb(255,255,255)",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-34",
    fill: "rgb(255,255,255)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-full-circle-35",
    fill: "rgb(255,255,255)",
    fillOpacity: 0.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFxCircle2);
export default __webpack_public_path__ + "static/media/fx-circle-2.7492201a97a81acaee625a76d5e2900c.svg";
export { ForwardRef as ReactComponent };